/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

class ActionLink extends React.Component {
  static defaultProps = {
    imagePath: '',
    hoverImagePath: '',
    imageAlign: 'left',
    linkText: 'Action Link Text',
    hideText: false,
    customClasses: '',
  };

  static propTypes = {
    onClickAction: PropTypes.func.isRequired,
    imagePath: PropTypes.string,
    hoverImagePath: PropTypes.string,
    imageAlign: PropTypes.string,
    linkText: PropTypes.string,
    hideText: PropTypes.bool,
    customClasses: PropTypes.string,
  }

  constructor(props) {
    super(props);
    this.state = {
      inHoverState: false,
    };
    this.handleOnMouseEnter = this.handleOnMouseEnter.bind(this);
    this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this);
  }

  handleOnMouseEnter = () => {
    this.setState({ inHoverState: true });
  }

  handleOnMouseLeave = () => {
    this.setState({ inHoverState: false });
  }

  render = () => {
    const {
      onClickAction,
      imagePath,
      hoverImagePath,
      imageAlign,
      linkText,
      hideText,
      customClasses,
    } = this.props;

    const { inHoverState } = this.state;

    let image = '';
    let cssAlign = '';
    if (imageAlign === 'left') {
      cssAlign = styles.alignLeft;
    }
    if (imageAlign === 'right') {
      cssAlign = styles.alignRight;
    }

    const imageUrl = inHoverState ? hoverImagePath : imagePath;
    if (imageUrl.length) {
      image = <img src={imageUrl} alt="Action Link" className={cssAlign} />;
    }
    return (
      <a
        onMouseEnter={this.handleOnMouseEnter}
        onMouseLeave={this.handleOnMouseLeave}
        onClick={onClickAction}
        role="button"
        tabIndex={0}
        className={`${styles.actionLink} ${customClasses}`}
      >
        {image}
        {' '}
        {!hideText && linkText}
      </a>
    );
  }
}

export default ActionLink;
